module.exports = __webpack_public_path__ + "img/fukidashi-p02.5fab9943.png";